module.exports = __webpack_public_path__ + "static/FullLiquid2-1c4307ffed592bb6b0fdce077f968e56.png";